module.exports = __webpack_public_path__ + "media/components/global/promos/redirector-app-notice/img/bkg-c80014c6dcf97ade714824891d8c7040.png";